/** M-WF-01 · Anteprima modifiche: "Cartellino attuale → Compila Orari" con scelta per giornata.
 * Ore lavorate, ordinarie ed eccedenza sempre distinte; senza regola aziendale l'eccedenza va qualificata. */
import React from "react";
import { ChangeReviewTable } from "@/foundation/review";
import { formatDuration, useDurationFormat } from "@/foundation/duration";
import { formatDateIT } from "@/foundation/formatting";

const WD = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
export const QUALIFICATION_LABELS = { STRAORDINARIO: "Straordinario", BANCA_ORE: "Banca ore", NOT_RECOGNIZED: "Non riconoscere" };

function Causes({ hours, changed, label, fmt, highlight }) {
  const entries = Object.entries(hours || {});
  if (!entries.length) return <span className="text-suite-neutral-300">vuota</span>;
  return (
    <span className="flex flex-wrap gap-1 font-mono">
      {entries.map(([k, v]) => (
        <span key={k} className={`rounded px-1 ${highlight && changed.includes(k) ? "bg-amber-100 text-amber-900 font-semibold" : "bg-suite-neutral-100"}`}>{label(k)} {formatDuration(v, fmt)}</span>
      ))}
    </span>
  );
}

function ExcessLine({ row, value, onChange, readOnly, fmt }) {
  const h = row.hours;
  if (!h?.excess) return null;
  const testid = `timesheet-excess-${row.date}`;
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-[11px]" data-testid={testid}>
      <span className="rounded bg-orange-50 px-1 font-mono text-orange-800">Eccedenza {formatDuration(h.excess, fmt)}</span>
      {row.excess_rule ? (
        <span className="text-suite-neutral-500" data-testid={`${testid}-rule`}>→ {QUALIFICATION_LABELS[row.excess_rule]} (regola aziendale)</span>
      ) : readOnly ? (
        <span className="text-suite-neutral-500">da qualificare</span>
      ) : (
        <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-select`}
          className={`h-6 rounded border px-1 text-[11px] ${value ? "border-suite-neutral-300" : "border-orange-400 bg-orange-50 text-orange-800"}`}>
          <option value="">Da qualificare…</option>
          {Object.entries(QUALIFICATION_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      )}
    </div>
  );
}

export function TimesheetReview({ rows, decisions, onChange, qualifications = {}, onQualify, readOnly, causeLabel }) {
  const fmt = useDurationFormat();
  const items = rows.map((r) => ({ ...r, key: r.date }));
  const nextHours = (r) => (r.needs_qualification && qualifications[r.date] ? r.variants[qualifications[r.date]] : { cause_hours: r.new.cause_hours, changed: r.changed });
  return (
    <ChangeReviewTable rows={items} decisions={decisions} onChange={onChange} readOnly={readOnly} testid="timesheet-review"
      labels={{ key: "Giorno", current: "Cartellino attuale", next: "Da Compila Orari" }}
      renderKey={(r) => <>{formatDateIT(r.date)} <span className="text-suite-neutral-400">{WD[new Date(`${r.date}T00:00:00`).getDay()]}</span></>}
      renderCurrent={(r) => <Causes hours={r.current.cause_hours} changed={r.changed} label={causeLabel} fmt={fmt} />}
      renderNext={(r) => {
        const n = nextHours(r);
        return (
          <div className="space-y-0.5">
            <div className="font-mono text-[10px] text-suite-neutral-500" data-testid={`timesheet-hours-${r.date}`}>
              Lavorate {formatDuration(r.hours?.worked ?? r.new.worked_hours, fmt)} · Ordinarie {formatDuration(r.hours?.ordinary ?? 0, fmt)}
              {r.hours?.justified ? ` · Giustificate ${formatDuration(r.hours.justified, fmt)}` : ""}
            </div>
            <Causes hours={n.cause_hours} changed={n.changed} label={causeLabel} fmt={fmt} highlight={r.kind === "conflict"} />
            <ExcessLine row={r} value={qualifications[r.date]} onChange={(q) => onQualify?.({ ...qualifications, [r.date]: q || undefined })} readOnly={readOnly} fmt={fmt} />
            <div className="font-mono text-[10px] text-suite-neutral-400">{r.new.intervals.map((iv) => `${iv.start}–${iv.end}`).join("  ")}</div>
          </div>
        );
      }} />
  );
}

export default TimesheetReview;
